<template>
  <div id="contact">
    <InputTmp v-if="'input' == page" v-on:change-page="changePage" v-bind:formData="formData"/>
    <ConfirmTmp v-else-if="'confirm' == page" v-on:change-page="changePage" v-bind:data="formData"/>
    <ThanksTmp v-else  v-on:change-page="changePage"/>
  </div>
</template>

<script>
import InputTmp from './components/InputTmp'
import ConfirmTmp from './components/ConfirmTmp'
import ThanksTmp from './components/ThanksTmp'

export default {
  name: 'App',
  components: {
    InputTmp,
    ConfirmTmp,
    ThanksTmp
  },
  data () {
    return {
      page: 'input',
      formData: {
        name: '',
        ruby: '',
        tel: '',
        mail: '',
        comment: ''
      }
    }
  },
  methods: {
    changePage (pageName, data) {
      this.page = pageName;
      if (data) this.formData = data;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue